import React from 'react';
import AppIcons from '../../assets/images/icons';
// import { Link } from '@mui/material';
// import { Link } from "react-router-dom";
// import ListCarousel from '../ListCarousel/ListCarousel';

import TestimonialsList from '../TestimonialsList/TestimonialsList';
import { ScrollToTopOnMount } from '../ScrollToTop/ScrollToTop';
import TrustedPartners from '../TrustedPartners/TrustedPartners';
import Services from '../Services/Services';
import OtherServices from '../Services/OtherServices';


import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import { Stack, Grid, TextField } from '@mui/material';


import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';


import ListItem from '@mui/material/ListItem';

import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import FormGroup from '@mui/material/FormGroup';

import fileUpload from '../../assets/images/icons/fileUpload.svg';

import './traditional.scss';


const TraditionalPage = () => {

  const [modalopen, setModalopen] = React.useState(false);
  const handleOpen = () => {
    setModalopen(true);
  };
  const handleClose = () => {
    setModalopen(false);
  };

  const [modalopen1, setModalopen1] = React.useState(false);
  const handleOpen1 = () => {
    setModalopen1(true);
  };
  const handleClose1 = () => {
    setModalopen1(false);
  };

  const [modalopen2, setModalopen2] = React.useState(false);
  const handleOpen2 = () => {
    setModalopen2(true);
  };
  const handleClose2 = () => {
    setModalopen2(false);
  };

  const [modalopen3, setModalopen3] = React.useState(false);
  const handleOpen3 = () => {
    setModalopen3(true);
  };
  const handleClose3 = () => {
    setModalopen3(false);
  };

  const [modalopen4, setModalopen4] = React.useState(false);
  const handleOpen4 = () => {
    setModalopen4(true);
  };
  const handleClose4 = () => {
    setModalopen4(false);
  };




  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };
  const [checked, setChecked] = React.useState([0]);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  

  ScrollToTopOnMount();
  return (
    <div id='app-main-content' className="main-content-wrapper f-wrp">

      <div className='traditional-about-wrp f-wrp'>
        <span className='traditionalBG'><img src={AppIcons.traditionalBG} alt='traditional' /></span>
        {/* <div className='container'>
          <div className='about-main-wrp f-wrp'>
            <div className="theme-page-switch">
              <ul>
                <li><Link to={'/fractional'} >Fractional</Link></li>
                <li><span>Traditional</span></li>
              </ul>
            </div>

            <div className='about-con-wrp f-wrp'>
              <h3>About us</h3>
              <p>Propshop has been driven by a relentless pursuit of excellence and innovation in everything we do. From curating the finest selection of luxury properties to stepping into crytocurrency and fractional markets, we are committed to delivering nothing but the best for our clients.</p>
            </div>
          </div>
        </div> */}
      </div>


      {/* <div className='listing-main-wrapp f-wrp'>
        <div className='container'>
          <div className='list-header f-wrp'>
            <ul>
              <li><label>Exclusive Listings</label></li>
              <li><Link to={'/exclusive-listings'}>View all</Link></li>
            </ul>
          </div>
          <div className='list-slider-wrp f-wrp'>
            <ListCarousel />
          </div>
        </div>
      </div> */}

      <div className='testimonials-main-wrpp service-main-wrp f-wrp' style={{ paddingBottom: '0' }} id='Services'>
        <div className='container'>
          <div className='value-header f-wrp'>
            <h1>Services</h1>
          </div>
          <div className='service-sec-blk f-wrp'>
            <Services />
          </div>
        </div>
        <div className='service-honey-comb-sec f-wrp'>

          <div className='honey-comb-head f-wrp'>
            <h1>One stop solution for everything real estate</h1>
          </div>

          <div className='service-honey-comb f-wrp'>
            <ul className="honeycomb">
              <li className="honeycomb-cell" onClick={handleOpen}>
                <img
                  className="honeycomb-cell__image"
                  src={AppIcons.honeyComb} alt="service"
                />
                <div className="honeycomb-cell__title">
                  <span><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.2483 7.58337C14.5759 7.58359 13.914 7.74983 13.3214 8.06733C12.7287 8.38483 12.2236 8.84376 11.8509 9.40337L3.47661 21.9614C2.96561 22.7314 2.90494 23.716 3.31794 24.542C7.90081 33.7075 14.2696 41.8644 22.0499 48.5334L26.1333 52.0357C26.6534 52.4816 27.316 52.7267 28.0011 52.7267C28.6862 52.7267 29.3488 52.4816 29.8689 52.0357L33.9523 48.5357C41.7338 41.8664 48.1034 33.7086 52.6866 24.542C53.0996 23.716 53.0366 22.7314 52.5256 21.9614L44.1466 9.40337C43.7739 8.84452 43.269 8.38625 42.6768 8.06919C42.0846 7.75212 41.4233 7.58605 40.7516 7.58571L15.2483 7.58337ZM14.7629 11.3424C14.8163 11.2626 14.8885 11.1972 14.9732 11.1521C15.0578 11.1069 15.1523 11.0833 15.2483 11.0834H20.7083L16.2399 21.8074C16.1376 22.0527 16.0594 22.3075 16.0066 22.568C14.3633 22.4454 12.722 22.2976 11.0833 22.1247L7.80494 21.7817L14.7629 11.3424ZM7.65327 25.284C11.8402 32.9655 17.367 39.8364 23.9726 45.5724L16.6809 26.1264C14.6915 25.9897 12.7048 25.817 10.7216 25.6084L7.65327 25.284ZM20.5006 26.3434L27.9999 46.3494L35.5016 26.3434C30.5031 26.5706 25.4968 26.5706 20.4983 26.3434H20.5006ZM39.3236 26.1264L32.0319 45.5724C38.6376 39.8364 44.1643 32.9655 48.3513 25.284L45.2829 25.6084C43.2996 25.816 41.3139 25.9887 39.3236 26.1264ZM48.1973 21.7817L44.9166 22.127C43.2779 22.2999 41.6365 22.4477 39.9933 22.5704C39.9414 22.3091 39.864 22.0535 39.7623 21.8074L35.2916 11.0834H40.7516C40.8476 11.0833 40.9421 11.1069 41.0267 11.1521C41.1114 11.1972 41.1836 11.2626 41.2369 11.3424L48.1973 21.7817ZM36.3836 22.7967C30.7999 23.086 25.2069 23.086 19.6209 22.7967L24.4999 11.0834H31.4999L36.3813 22.7967H36.3836Z" fill="black" />
                  </svg></span>
                  <p>After-Sales</p>
                </div>
              </li>
              <li className="honeycomb-cell" onClick={handleOpen1}>
                <img
                  className="honeycomb-cell__image"
                  src={AppIcons.honeyComb} alt="service"
                />
                <div className="honeycomb-cell__title">
                  <span> <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_782_7812)">
                      <g clip-path="url(#clip1_782_7812)">
                        <path d="M27.6084 32.0728C23.3834 32.0728 20.025 35.4311 20.025 39.6561C20.025 43.8811 23.3834 47.2394 27.6084 47.2394C31.8334 47.2394 35.1917 43.8811 35.1917 39.6561C35.1917 35.4311 31.8334 32.0728 27.6084 32.0728ZM27.6084 45.0728C24.575 45.0728 22.1917 42.6894 22.1917 39.6561C22.1917 36.6228 24.575 34.2394 27.6084 34.2394C30.6417 34.2394 33.025 36.6228 33.025 39.6561C33.025 42.6894 30.6417 45.0728 27.6084 45.0728Z" fill="white" />
                        <path d="M43.5335 36.0811L40.5001 35.1061L39.8501 33.4811L41.3668 30.6644C41.6918 30.0144 41.5835 29.1478 41.0418 28.6061L38.4418 26.0061C37.9001 25.4644 37.0335 25.3561 36.3835 25.6811L33.5668 27.1978L31.9418 26.5478L30.9668 23.5144C30.7501 22.8644 30.1001 22.3228 29.3418 22.3228H25.6584C24.9001 22.3228 24.2501 22.8644 24.1418 23.6228L23.1668 26.6561C22.5168 26.7644 21.9751 26.9811 21.4334 27.3061L18.6168 25.7894C17.9668 25.4644 17.1001 25.5728 16.5584 26.1144L13.9584 28.7144C13.4168 29.2561 13.3084 30.1228 13.6334 30.7728L15.0418 33.4811C14.8251 34.0228 14.6084 34.6728 14.3918 35.2144L11.3584 36.1894C10.7084 36.4061 10.1667 37.0561 10.1667 37.8144V41.4978C10.1667 42.2561 10.7084 42.9061 11.4667 43.1228L14.5001 44.0978L15.1501 45.7228L13.6334 48.5395C13.3084 49.1895 13.4168 50.0561 13.9584 50.5978L16.5584 53.1978C17.1001 53.7395 17.9668 53.8478 18.6168 53.5228L21.4334 52.0061L23.0584 52.6561L24.0334 55.7978C24.2501 56.4478 24.9001 56.9895 25.6584 56.9895H29.3418C30.1001 56.9895 30.7501 56.4478 30.9668 55.7978L31.9418 52.6561L33.5668 52.0061L36.3835 53.5228C37.0335 53.8478 37.9001 53.7395 38.4418 53.1978L41.0418 50.5978C41.5835 50.0561 41.6918 49.1895 41.3668 48.5395L39.8501 45.7228L40.5001 44.0978L43.6418 43.1228C44.2918 42.9061 44.8335 42.2561 44.8335 41.4978V37.8144C44.8335 37.0561 44.2918 36.2978 43.5335 36.0811ZM42.6668 41.1728L38.7668 42.3644L38.6585 42.9061L37.6835 45.1811L37.3585 45.7228L39.3085 49.2978L37.1418 51.4645L33.5668 49.5145L33.0251 49.8395C32.2668 50.2728 31.5084 50.5978 30.7501 50.8145L30.2084 50.9228L29.0168 54.8228H25.9834L24.7918 50.9228L24.2501 50.8145L21.9751 49.8395L21.4334 49.5145L17.8584 51.4645L15.6918 49.2978L17.6418 45.7228L17.3168 45.1811C16.8834 44.4228 16.5584 43.6644 16.3418 42.9061L16.2334 42.3644L12.3334 41.1728V38.1394L16.0168 37.0561L16.2334 36.5144C16.4501 35.6478 16.7751 34.8894 17.2084 34.1311L17.5334 33.5894L15.6918 30.0144L17.8584 27.8478L21.3251 29.7978L21.8668 29.4728C22.6251 29.0394 23.3834 28.7144 24.2501 28.4978L24.7918 28.2811L25.9834 24.4894H29.0168L30.2084 28.2811L30.7501 28.4978C31.5084 28.7144 32.2668 29.0394 33.0251 29.4728L33.5668 29.7978L37.1418 27.8478L39.3085 30.0144L37.3585 33.5894L37.6835 34.1311C38.1168 34.8894 38.4418 35.6478 38.6585 36.4061L38.7668 36.9478L42.6668 38.1394V41.1728Z" fill="white" />
                      </g>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M29.2957 0.145439C29.6719 0.00991278 30.0715 -0.0316388 30.4647 0.0239025C30.8578 0.0794437 31.2342 0.230635 31.5656 0.46613C31.8971 0.701625 32.1749 1.01531 32.3783 1.38363C32.5817 1.75196 32.7054 2.16537 32.7401 2.59283L32.7506 2.84287V13.2348L39.3908 14.6744C39.9442 14.7938 40.4473 15.1029 40.8256 15.556C41.2039 16.0092 41.4372 16.5821 41.491 17.19L41.5016 17.459V31.8365H43.2517C43.6978 31.837 44.1269 32.0219 44.4513 32.3533C44.7756 32.6848 44.9708 33.1377 44.997 33.6197C45.0231 34.1017 44.8782 34.5763 44.5919 34.9465C44.3056 35.3168 43.8995 35.5547 43.4565 35.6117L43.2517 35.625H11.7483C11.3022 35.6245 10.8731 35.4396 10.5487 35.1082C10.2244 34.7767 10.0292 34.3237 10.003 33.8417C9.97687 33.3598 10.1218 32.8852 10.4081 32.5149C10.6944 32.1447 11.1005 31.9068 11.5435 31.8497L11.7483 31.8365H13.4984V7.89298C13.4984 6.75642 14.1215 5.74109 15.0701 5.29026L15.2941 5.19744L29.2957 0.145439ZM29.2502 4.15749L16.9988 8.57681V31.8365H29.2502V4.15749ZM32.7506 17.101V31.8365H38.0012V18.2357L32.7506 17.101Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_782_7812">
                        <rect width="56" height="57" fill="white" />
                      </clipPath>
                      <clipPath id="clip1_782_7812">
                        <rect width="39.0001" height="19.5" fill="white" transform="translate(8 39.656)" />
                      </clipPath>
                    </defs>
                  </svg> </span>

                  <p>Property management</p>
                </div>
              </li>
              <li className="honeycomb-cell" onClick={handleOpen3}>
                <img
                  className="honeycomb-cell__image"
                  src={AppIcons.honeyComb} alt="service"
                />
                <div className="honeycomb-cell__title">
                  <span><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M26.1975 47.6745C26.1029 48.0531 25.8844 48.3892 25.5769 48.6294C25.2693 48.8696 24.8903 49.0001 24.5 49.0001C24.3526 49.0008 24.2056 48.9832 24.0625 48.9476L17.0625 47.1976C16.8676 47.1487 16.6827 47.0665 16.5157 46.9548L11.2657 43.4548C10.8796 43.1972 10.6116 42.7968 10.5207 42.3416C10.4299 41.8865 10.5235 41.4139 10.7811 41.0278C11.0387 40.6417 11.4391 40.3737 11.8943 40.2829C12.3494 40.192 12.8221 40.2857 13.2082 40.5432L18.2044 43.8748L24.9113 45.5526C25.1354 45.6069 25.3465 45.705 25.5326 45.8412C25.7186 45.9774 25.8759 46.149 25.9955 46.3462C26.115 46.5434 26.1944 46.7622 26.2291 46.9902C26.2637 47.2181 26.253 47.4507 26.1975 47.6745ZM55.2235 26.5739C55.0799 27.01 54.8513 27.4134 54.5509 27.7607C54.2506 28.108 53.8844 28.3923 53.4735 28.5973L48.2935 31.1873L36.2447 43.2382C36.0309 43.4519 35.7653 43.6065 35.474 43.687C35.1826 43.7675 34.8754 43.7711 34.5822 43.6976L20.5822 40.1976C20.3693 40.1442 20.1683 40.0514 19.9894 39.9242L7.8444 31.2529L2.53316 28.5973C1.70308 28.1824 1.07178 27.4547 0.778066 26.5744C0.484355 25.6941 0.55228 24.7332 0.966905 23.9029L6.40284 13.0332C6.8178 12.2032 7.54543 11.5719 8.42574 11.2782C9.30605 10.9844 10.267 11.0524 11.0972 11.467L15.9228 13.8732L27.5166 10.5614C27.8311 10.4714 28.1646 10.4714 28.4791 10.5614L40.0728 13.8732L44.8985 11.467C45.7287 11.0524 46.6896 10.9844 47.5699 11.2782C48.4503 11.5719 49.1779 12.2032 49.5928 13.0332L55.0288 23.9029C55.2361 24.3132 55.3601 24.7605 55.3935 25.2189C55.4269 25.6774 55.3691 26.1379 55.2235 26.5739ZM45.1216 29.4045L39.1694 17.5001H32.2088L22.75 26.6876C25.5194 28.4573 29.8616 28.9451 33.7575 25.0186C34.0618 24.7119 34.4688 24.5286 34.9001 24.5039C35.3314 24.4793 35.7566 24.6151 36.0938 24.8851L43.621 30.9161L45.1216 29.4045ZM4.09722 25.467L7.9669 27.4029L13.4028 16.5332L9.53315 14.5973L4.09722 25.467ZM41.125 33.3945L35.0635 28.5404C30.7891 32.0404 25.3619 32.502 20.8644 29.6342C20.422 29.3528 20.0485 28.9755 19.7714 28.5304C19.4944 28.0852 19.3209 27.5835 19.2638 27.0623C19.2066 26.5411 19.2674 26.0137 19.4414 25.5191C19.6155 25.0245 19.8984 24.5754 20.2694 24.2048C20.2747 24.1984 20.2805 24.1926 20.2869 24.1873L30.1 14.6695L28 14.0701L16.9707 17.2223L10.9835 29.1945L21.746 36.8836L34.4641 40.062L41.125 33.3945ZM51.8963 25.467L46.4669 14.5973L42.5972 16.5332L48.0332 27.4029L51.8963 25.467Z" fill="white" />
                  </svg></span>

                  <p>Rental services</p>
                </div>
              </li>
              <li className="honeycomb-cell" onClick={handleOpen4}>
                <img
                  className="honeycomb-cell__image"
                  src={AppIcons.bgBlk} alt="service"
                />
                <div className="honeycomb-cell__title">
                  {/* <span><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M30.4045 4.4169C29.7547 3.80253 28.8943 3.46021 28 3.46021C27.1057 3.46021 26.2453 3.80253 25.5955 4.4169L8.6415 20.4399C8.12239 20.9311 7.70904 21.5232 7.42678 22.1798C7.14452 22.8364 6.99929 23.5437 7 24.2584V43.7534C7.00093 45.1452 7.55446 46.4796 8.53893 47.4635C9.52339 48.4473 10.8582 48.9999 12.25 48.9999H27.692L24.22 45.4999H12.25C11.7859 45.4999 11.3408 45.3155 11.0126 44.9873C10.6844 44.6592 10.5 44.214 10.5 43.7499V24.2549C10.4999 24.0171 10.5483 23.7819 10.6422 23.5634C10.7361 23.345 10.8735 23.148 11.046 22.9844L28 6.9579L42.868 21.0174C44.8028 20.9157 46.7347 21.2668 48.51 22.0429C48.23 21.4479 47.845 20.9019 47.355 20.4434L30.4045 4.4169ZM49 26.3759C47.2765 25.0369 45.1221 24.3758 42.9441 24.5177C40.7662 24.6595 38.7157 25.5946 37.1805 27.1459L36.75 27.5799L36.3195 27.1494C35.4902 26.309 34.5023 25.6416 33.4129 25.1862C32.3236 24.7307 31.1547 24.4961 29.974 24.4961C28.7933 24.4961 27.6244 24.7307 26.5351 25.1862C25.4458 25.6416 24.4578 26.309 23.6285 27.1494C21.9449 28.8511 21.0006 31.1483 21.0006 33.5422C21.0006 35.936 21.9449 38.2332 23.6285 39.9349L35.6335 52.0344C35.7793 52.1818 35.9529 52.2988 36.1443 52.3787C36.3356 52.4586 36.5409 52.4997 36.7483 52.4997C36.9556 52.4997 37.1609 52.4586 37.3522 52.3787C37.5436 52.2988 37.7172 52.1818 37.863 52.0344L49.8715 39.9349C50.7737 39.0221 51.4724 37.9286 51.9217 36.7265C52.371 35.5243 52.5607 34.2406 52.4784 32.9598C52.3961 31.6791 52.0435 30.4303 51.444 29.2955C50.8445 28.1607 50.0116 27.1657 49 26.3759Z" fill="#1D1D1B" />
                                    </svg></span> */}

                  <img
                    className="logoimg" style={{ width: '55px' }}
                    src={AppIcons.honeylogo} alt="service"
                  />
                  {/* <p>Real Estate Matchmaking</p> */}
                </div>
              </li>
              <li className="honeycomb-cell" onClick={handleOpen2}>
                <img
                  className="honeycomb-cell__image"
                  src={AppIcons.honeyComb} alt="service"
                />
                <div className="honeycomb-cell__title">
                  <span> <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M54.2753 26.6066C54.0521 26.2144 53.753 25.8706 53.3954 25.5953C53.0379 25.32 52.6291 25.1187 52.1928 25.0031C50.6103 24.5958 48.975 24.432 47.3432 24.5175C48.2182 20.1753 47.5619 16.7409 46.8925 14.7044C46.6257 13.8678 46.0569 13.1606 45.297 12.7206C44.5371 12.2806 43.6406 12.1393 42.7822 12.3244C40.5563 12.8201 38.4397 13.7186 36.5369 14.9756C35.1434 12.1289 33.1144 9.64041 30.6066 7.70219C29.9989 7.24639 29.2597 7 28.5 7C27.7404 7 27.0012 7.24639 26.3935 7.70219C23.8851 9.63985 21.856 12.1285 20.4632 14.9756C18.5604 13.7186 16.4438 12.8201 14.2178 12.3244C13.3595 12.1393 12.4629 12.2806 11.703 12.7206C10.9431 13.1606 10.3743 13.8678 10.1075 14.7044C9.45128 16.7409 8.79503 20.1731 9.65691 24.5175C8.02506 24.432 6.38972 24.5958 4.80722 25.0031C4.371 25.1187 3.96218 25.32 3.60463 25.5953C3.24707 25.8706 2.94795 26.2144 2.72472 26.6066C2.49111 27.0083 2.33984 27.4526 2.27975 27.9134C2.21966 28.3742 2.25194 28.8424 2.37472 29.2906C3.11628 32.0403 5.39347 37.2706 12.2907 41.3919C19.1878 45.5131 25.2472 45.5 28.511 45.5C31.7747 45.5 37.845 45.5 44.6985 41.3919C51.5957 37.2706 53.8728 32.0403 54.6144 29.2906C54.7388 28.8431 54.7729 28.3753 54.7147 27.9145C54.6565 27.4537 54.5071 27.0091 54.2753 26.6066ZM13.4369 15.7806C13.4395 15.7698 13.4462 15.7603 13.4555 15.7542C13.4649 15.7481 13.4762 15.7458 13.4872 15.7478C15.5227 16.2076 17.4435 17.0761 19.1332 18.3006C18.3638 20.8175 17.9817 23.4367 18 26.0684C18 30.1678 18.8247 33.5059 19.9928 36.1922C18.3322 34.5301 16.8953 32.6586 15.7185 30.625C11.7766 23.7606 12.5969 18.375 13.4369 15.7806ZM14.0932 38.3884C8.25909 34.9059 6.36691 30.6359 5.75003 28.3719C7.35964 27.9756 9.02988 27.8887 10.6719 28.1159C11.2201 29.5844 11.8896 31.0046 12.6735 32.3619C14.5982 35.6802 17.1197 38.614 20.111 41.0156C17.9958 40.4075 15.9696 39.5242 14.0844 38.3884H14.0932ZM28.5 41.65C26.4591 40.1319 21.5 35.4747 21.5 26.0684C21.5 16.7781 26.3957 12.0837 28.5 10.5C30.6044 12.0881 35.5 16.7825 35.5 26.0728C35.5 35.4747 30.541 40.1319 28.5 41.65ZM37.8669 18.3006C39.5568 17.0769 41.4776 16.2091 43.5128 15.75C43.5238 15.748 43.5352 15.7503 43.5445 15.7564C43.5539 15.7625 43.5605 15.772 43.5632 15.7828C44.4032 18.375 45.2235 23.7606 41.2816 30.625C40.1058 32.6613 38.6688 34.5351 37.0072 36.1987C38.1753 33.5169 39 30.1744 39 26.075C39.019 23.4411 38.6369 20.8196 37.8669 18.3006ZM51.25 28.3763C50.6441 30.6184 48.7563 34.8972 42.9178 38.3884C41.0325 39.5234 39.0064 40.406 36.8913 41.0134C39.8826 38.6118 42.4041 35.678 44.3288 32.3597C45.1127 31.0024 45.7822 29.5822 46.3303 28.1138C47.9719 27.8876 49.6415 27.9759 51.25 28.3741V28.3763Z" fill="black" />
                  </svg></span>

                  <p>Concierge</p>
                </div>
              </li>
              <li className="honeycomb-cell honeycomb__placeholder" />
            </ul>
          </div>

        </div>
      </div>

      <div className='othr-service-main-wrp f-wrp' id='OtherServices'>
        <div className='container'>
          <div className='value-header f-wrp'>
            <h1>Other services</h1>
          </div>
          <OtherServices />
        </div>

      </div>

      {/* <div className='gap f-wrp' style={{background: '#F8F8F8', paddingBottom: '45px', paddingTop: '45px',}}></div> */}

      <div className='testimonials-main-wrpp f-wrp' id='testimonials'>
        <div className='container'>
          <div className='value-header f-wrp'>
            <h1>Testimonials</h1>
          </div>
          <div className='testimonial-slider-sec f-wrp'>
            <TestimonialsList />
          </div>
        </div>
      </div>

      {/* <div className='gap f-wrp' style={{ background: '#F8F8F8', paddingBottom: '45px' }}></div>

      <div className='value-main-wrpp f-wrp' style={{ background: '#F8F8F8' }} id='TopDevelopers'>
        <div className='container'>
          <div className='value-header f-wrp'>
            <h1>Top developers</h1>
            <p style={{ paddingLeft: '15px', display: 'none' }}>We collaborate with every exceptional developer in the building industry, however these rise as our favorites. </p>
          </div>
          <div className="value-grid-wrp f-wrp">
            <TopDevelopers />
          </div>
        </div>
      </div> */}
      {/* <div className='gap f-wrp' style={{ background: '#F8F8F8', paddingBottom: '45px' }}></div> */}

      <div className='gap f-wrp' style={{ background: '#F8F8F8', paddingBottom: '55px', }}></div>

      <div className='value-main-wrpp f-wrp' style={{ background: '#F8F8F8' }} id='TrustedPartners'>
        <div className='container'>
          <div className='value-header f-wrp'>
            <h1>Trusted partners</h1>
          </div>
          <div className="value-grid-wrp f-wrp">
            <TrustedPartners />
          </div>
        </div>
      </div>
      <div className='gap f-wrp' style={{ background: '#F8F8F8', paddingTop: '45px', paddingBottom: '55px', }}></div>

      <div className="modal-learn-more-wrp after-sales f-wrp">
        <Modal open={modalopen} onClose={handleClose}>
          <Box >
            <div className="learn-more-form f-wrp">
              <div className="form-header">
                <h2>After-Sales</h2>
                <Button onClick={handleClose} className='close-btn'><svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.53329 25.8334L6.66663 23.9667L14.1333 16.5001L6.66663 9.03341L8.53329 7.16675L16 14.6334L23.4666 7.16675L25.3333 9.03341L17.8666 16.5001L25.3333 23.9667L23.4666 25.8334L16 18.3667L8.53329 25.8334Z" fill="#1D1D1B" />
                </svg>
                </Button>
              </div>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl component="fieldset">
                    <FormLabel className='form-title' id="prop-type">I need</FormLabel>
                    <FormGroup aria-label="prop-type" className='sales-checkbox' row>
                      <FormControlLabel
                        value="Feng Shui Vastu shastra"
                        control={<Checkbox />}
                        label="Feng Shui · Vastu shastra"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Interior design"
                        control={<Checkbox />}
                        label="Interior design"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Construction"
                        control={<Checkbox />}
                        label="Construction"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Other"
                        control={<Checkbox />}
                        label="Other"
                        labelPlacement="end"
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type='text'
                      defaultValue=""
                      name="name" label="Name*" />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type="number"
                      id="phone"
                      label="Phone*"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField
                      id="email"
                      label="Email*"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type='text'
                      multiline
                      rows={4}
                      name="message" label="Message*" defaultValue="" />
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <Button className='submit-btn'>Submit</Button>
                  </Stack>
                </Grid>
              </Grid>
              <p className="info-txt">Not finding what you are looking for? Contact us on <span onClick={() => window.open('https://wa.me/971568816886', '_blank')}>Whatsapp</span> or  <span onClick={() => onclick = "window.location.href = 'tel:971568816886';"}>Call</span>.</p>
            </div>
          </Box>
        </Modal>
      </div>

      <div className="modal-learn-more-wrp property-management f-wrp">
        <Modal open={modalopen1} onClose={handleClose1}>
          <Box >
            <div className="learn-more-form f-wrp">

              <div className="form-header">
                <h2>Property management</h2>
                <Button onClick={handleClose1} className='close-btn'><svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.53329 25.8334L6.66663 23.9667L14.1333 16.5001L6.66663 9.03341L8.53329 7.16675L16 14.6334L23.4666 7.16675L25.3333 9.03341L17.8666 16.5001L25.3333 23.9667L23.4666 25.8334L16 18.3667L8.53329 25.8334Z" fill="#1D1D1B" />
                </svg>
                </Button>
              </div>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl>
                    <FormLabel className='form-title' id="property-type">Property type</FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="property-type"
                      name="property-type"
                    >
                      <FormControlLabel value="Residential" control={<Radio />} label="Residential" />
                      <FormControlLabel value="Commercial" control={<Radio />} label="Commercial" />
                      <FormControlLabel value="Industrial" control={<Radio />} label="Industrial" />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <FormControl component="fieldset">
                    <FormLabel className='form-title' id="prop-type">I need</FormLabel>
                    <FormGroup aria-label="prop-type" row>
                      <FormControlLabel
                        value="management"
                        control={<Checkbox />}
                        label="Management"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Rental"
                        control={<Checkbox />}
                        label="Rental"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Buying-selling"
                        control={<Checkbox />}
                        label="Buying & selling"
                        labelPlacement="end"
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type='text'
                      defaultValue=""
                      name="name" label="Name*" />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type="number"
                      id="phone"
                      label="Phone*"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField
                      id="email"
                      label="Email*"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type='text'
                      multiline
                      rows={4}
                      name="message" label="Message*" defaultValue="" />
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <FormControl className='fileUpload' component="fieldset">
                    <label htmlFor="prop-img"><img src={fileUpload} alt="fileUpload" />
                      <input
                        accept="image/*"
                        className="property-image"
                        id="prop-img"
                        multiple
                        type="file"
                      // onChange={this.handleUploadClick}
                      />
                    </label>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <Button className='submit-btn'>Submit</Button>
                  </Stack>
                </Grid>
              </Grid>
              <p className="info-txt">Not finding what you are looking for? Contact us on <span onClick={() => window.open('https://wa.me/971568816886', '_blank')}>Whatsapp</span> or  <span onClick={() => onclick = "window.location.href = 'tel:971568816886';"}>Call</span>.</p>
            </div>
          </Box>
        </Modal>
      </div>

      <div className="modal-learn-more-wrp concierge f-wrp">
        <Modal open={modalopen2} onClose={handleClose2}>
          <Box >
            <div className="learn-more-form f-wrp">
              <div className="form-header">
                <h2>Concierge</h2>
                <Button onClick={handleClose2} className='close-btn'><svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.53329 25.8334L6.66663 23.9667L14.1333 16.5001L6.66663 9.03341L8.53329 7.16675L16 14.6334L23.4666 7.16675L25.3333 9.03341L17.8666 16.5001L25.3333 23.9667L23.4666 25.8334L16 18.3667L8.53329 25.8334Z" fill="#1D1D1B" />
                </svg>
                </Button>
              </div>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl component="fieldset">
                    <FormLabel className='form-title' id="prop-type">I need</FormLabel>
                    <FormGroup aria-label="prop-type" className='sales-checkbox' row>
                      <FormControlLabel
                        value="Life style concierge"
                        control={<Checkbox />}
                        label="Life style concierge"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Business concierge"
                        control={<Checkbox />}
                        label="Business concierge"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Permanent residency"
                        control={<Checkbox />}
                        label="Permanent residency"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Other"
                        control={<Checkbox />}
                        label="Other"
                        labelPlacement="end"
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type='text'
                      defaultValue=""
                      name="name" label="Name*" />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type="number"
                      id="phone"
                      label="Phone*"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField
                      id="email"
                      label="Email*"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type='text'
                      multiline
                      rows={4}
                      name="message" label="Message*" defaultValue="" />
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <Button className='submit-btn'>Submit</Button>
                  </Stack>
                </Grid>
              </Grid>
              <p className="info-txt">Not finding what you are looking for? Contact us on <span onClick={() => window.open('https://wa.me/971568816886', '_blank')}>Whatsapp</span> or  <span onClick={() => onclick = "window.location.href = 'tel:971568816886';"}>Call</span>.</p>
            </div>
          </Box>
        </Modal>
      </div>

      <div className="modal-learn-more-wrp rental-services f-wrp">
        <Modal open={modalopen3} onClose={handleClose3}>
          <Box >
            <div className="learn-more-form f-wrp">

              <div className="form-header">
                <h2>Rental services</h2>
                <Button onClick={handleClose3} className='close-btn'><svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.53329 25.8334L6.66663 23.9667L14.1333 16.5001L6.66663 9.03341L8.53329 7.16675L16 14.6334L23.4666 7.16675L25.3333 9.03341L17.8666 16.5001L25.3333 23.9667L23.4666 25.8334L16 18.3667L8.53329 25.8334Z" fill="#1D1D1B" />
                </svg>
                </Button>
              </div>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <List
                      sx={{ width: '100%', maxWidth: '100%', bgcolor: 'background.paper' }}
                      component="nav"
                      aria-labelledby="nested-list-subheader" className="selectList"
                    >
                      <ListItemButton onClick={handleClick}>
                        <ListItemText primary="Select from list" />
                        {open ? <span className="reverse"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 12L16 20L24 12" stroke="#1D1D1B" strokeWidth="2.66667" strokeLinecap="round" stroke-linejoin="round" />
                        </svg>
                        </span> : <span><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 12L16 20L24 12" stroke="#1D1D1B" strokeWidth="2.66667" strokeLinecap="round" stroke-linejoin="round" />
                        </svg>
                        </span>}
                      </ListItemButton>
                      <Collapse in={open} timeout="auto" unmountOnExit>

                        <List sx={{ width: '100%', maxWidth: '100%', bgcolor: 'background.paper' }} className="serviceList">
                          {['Property Listing',
                            'Property Showings',
                            'Property evaluation',
                            'Tenant Screening',
                            'Eviction Assistance',
                            'Lease Preparation',
                            'Maintenance and Repairs',
                            'Other',].map((value) => {
                              const labelId = `${value}`;

                              return (
                                <ListItem
                                  key={value}
                                  secondaryAction={
                                    <IconButton edge="end" aria-label="comments">

                                    </IconButton>
                                  }
                                  disablePadding
                                >
                                  <ListItemButton role={undefined} onClick={handleToggle(value)} dense>
                                    <ListItemText id={labelId} primary={`${value}`} />
                                    <ListItemIcon>
                                      <Checkbox
                                        edge="start"
                                        checked={checked.indexOf(value) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                      />
                                    </ListItemIcon>
                                  </ListItemButton>
                                </ListItem>
                              );
                            })}
                        </List>
                      </Collapse>
                    </List>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type='text'
                      defaultValue=""
                      name="name" label="Name*" />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type="number"
                      id="phone"
                      label="Phone*"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField
                      id="email"
                      label="Email*"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type='text'
                      multiline
                      rows={4}
                      name="message" label="Message*" defaultValue="" />
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <Button className='submit-btn'>Submit</Button>
                  </Stack>
                </Grid>
              </Grid>
              <p className="info-txt">Not finding what you are looking for? Contact us on <span onClick={() => window.open('https://wa.me/971568816886', '_blank')}>Whatsapp</span> or  <span onClick={() => onclick = "window.location.href = 'tel:971568816886';"}>Call</span>.</p>
            </div>
          </Box>
        </Modal>
      </div>

      <div className="modal-learn-more-wrp buying-selling f-wrp">
        <Modal open={modalopen4} onClose={handleClose4}>
          <Box >
            <div className="learn-more-form f-wrp">
              <div className="form-header">
                <h2>Buying and selling</h2>
                <Button onClick={handleClose4} className='close-btn'><svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.53329 25.8334L6.66663 23.9667L14.1333 16.5001L6.66663 9.03341L8.53329 7.16675L16 14.6334L23.4666 7.16675L25.3333 9.03341L17.8666 16.5001L25.3333 23.9667L23.4666 25.8334L16 18.3667L8.53329 25.8334Z" fill="#1D1D1B" />
                </svg>
                </Button>
              </div>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <List
                      sx={{ width: '100%', maxWidth: '100%', bgcolor: 'background.paper' }}
                      component="nav"
                      aria-labelledby="nested-list-subheader" className="selectList"
                    >
                      <ListItemButton onClick={handleClick}>
                        <ListItemText primary="Select from list" />
                        {open ? <span className="reverse"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 12L16 20L24 12" stroke="#1D1D1B" strokeWidth="2.66667" strokeLinecap="round" stroke-linejoin="round" />
                        </svg>
                        </span> : <span><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 12L16 20L24 12" stroke="#1D1D1B" strokeWidth="2.66667" strokeLinecap="round" stroke-linejoin="round" />
                        </svg>
                        </span>}
                      </ListItemButton>
                      <Collapse in={open} timeout="auto" unmountOnExit>

                        <List sx={{ width: '100%', maxWidth: '100%', bgcolor: 'background.paper' }} className="serviceList">
                          {['Property Listing',
                            'Property Showings',
                            'Property Inspections',
                            'Mortgage Assistance',
                            'Other',].map((value) => {
                              const labelId = `${value}`;

                              return (
                                <ListItem
                                  key={value}
                                  secondaryAction={
                                    <IconButton edge="end" aria-label="comments">

                                    </IconButton>
                                  }
                                  disablePadding
                                >
                                  <ListItemButton role={undefined} onClick={handleToggle(value)} dense>
                                    <ListItemText id={labelId} primary={`${value}`} />
                                    <ListItemIcon>
                                      <Checkbox
                                        edge="start"
                                        checked={checked.indexOf(value) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                      />
                                    </ListItemIcon>
                                  </ListItemButton>
                                </ListItem>
                              );
                            })}
                        </List>
                      </Collapse>
                    </List>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type='text'
                      defaultValue=""
                      name="name" label="Name*" />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type="number"
                      id="phone"
                      label="Phone*"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField
                      id="email"
                      label="Email*"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <TextField type='text'
                      multiline
                      rows={4}
                      name="message" label="Message*" defaultValue="" />
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <Stack className='login-form profile-form' spacing={3}>
                    <Button className='submit-btn'>Submit</Button>
                  </Stack>
                </Grid>
              </Grid>
              <p className="info-txt">Not finding what you are looking for? Contact us on <span onClick={() => window.open('https://wa.me/971568816886', '_blank')}>Whatsapp</span> or  <span onClick={() => onclick = "window.location.href = 'tel:971568816886';"}>Call</span>.</p>
            </div>
          </Box>
        </Modal>
      </div>
























































































































































    </div>
  )
}

export default TraditionalPage;